import React from 'react';
import { Checkbox } from 'components/Checkbox';
import FundsProtectionContent from 'components/FundsProtectionContent';
import './fundsProtectionCheck.css';

interface FundsProtectionCheckProps {
  selectedMethodType?: string;
  checked: boolean;
  onChange: () => void;
}

const FundsProtectionCheck = ({
  selectedMethodType,
  checked,
  onChange
}: FundsProtectionCheckProps) => (
  <div className="fieldset">
    <Checkbox
      onChange={onChange}
      checked={checked}
      className="fundsProtectionCheck"
      name="acceptFundProtectionTermsCheckbox"
      label="I accept the fund protection terms"
    />
    <FundsProtectionContent selectedMethodType={selectedMethodType} hasNotAcceptedTerms />
  </div>
);

export default FundsProtectionCheck;
